import { render, staticRenderFns } from "./AnalyticsOrdersNew.vue?vue&type=template&id=50317192"
import script from "./AnalyticsOrdersNew.vue?vue&type=script&lang=js"
export * from "./AnalyticsOrdersNew.vue?vue&type=script&lang=js"
import style0 from "./AnalyticsOrdersNew.vue?vue&type=style&index=0&id=50317192&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports